import { DialogModal, Radio, Typography } from '@up-riac/bespoke-ui';
import React, { useEffect } from 'react';
import { useMegaMenu } from 'src/components/Header/components/MegaMenu/useMegaMenu';
import { AnalyticsContext } from 'src/lib/AnalyticsContext';
import { useTheme } from 'src/lib/ThemeContext';

export const MegaMenuSettingsModal = () => {
  const { darkMode, setDarkMode } = useTheme();
  const { settingsMenuState } = useMegaMenu();
  const [oldDarkMode] = React.useState(darkMode);
  const { sendHotjarEvent } = React.useContext(AnalyticsContext);
  const onClose = (skipReset?: boolean) => {
    if(!skipReset) {
      setDarkMode(oldDarkMode);
    }
    settingsMenuState.close();
  };
  useEffect(() => {
    return () => {
      if(settingsMenuState.isOpen) { // Close on unmount.
        settingsMenuState.close();
      }
    };
  }, []);
  return <DialogModal
    data-dont-close-mega-menu={'true'}
    title='Settings'
    isDismissable isOpen={settingsMenuState.isOpen}
    onClose={() => onClose()}
    actions={{
      primary: {
        onPress: () => onClose(true),
        label: 'Save',
      },
      secondary: {
        onPress: () => onClose(),
        label: 'Cancel',
      },
    }}
  >
    <div className='py-1 min-w-[320px]'>
      <Radio
        label={<Typography weight='bold' heading size='xs' color='text'>Color theme</Typography>}
        description={<Typography color='text'>Switch between light and dark themes.</Typography>}
        value={darkMode}
        onChange={(value) => {
          setDarkMode(value as 'light' | 'dark' | 'system-default');
          sendHotjarEvent('UX-mega_menu_theme_changed');
        }}
        className='flex flex-col gap-1'
        excludeFromTabOrder
      >
        <Radio.Option value='light'>Light</Radio.Option>
        <Radio.Option value='dark'>Dark</Radio.Option>
        <Radio.Option value='system-default'>System theme (default)</Radio.Option>
      </Radio>
    </div>
  </DialogModal>;
};
